<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>物料管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">总仓物料</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!showIsIn && !showIsOut && !showIsExcelOut">
      <section class="searchBox">
        <span class="addStyle">
          <a-button @click="showIsIn = !showIsIn" type="primary" icon="plus"
            >总库入库</a-button
          >
          <a-button type="danger" @click="showIsOut = !showIsOut"
            >总库出库</a-button
          >
          <!-- <a-button @click="showIsExcelOut = !showIsExcelOut"
            >表格出库</a-button
          > -->
        </span>
        <span>
          <label>项目：</label>
          <a-select
            v-model="project_id"
            style="width:200px"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            placeholder="请选择项目"
          >
            <a-select-option
              v-for="(item, i) in proList"
              :key="i"
              :value="item.id"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            placeholder="请输入商品名称"
            style="width:200px"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button class="resetStyle" @click="downloadMaterial">
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
          <a-button @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="(item, j) in thList" :key="j">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.brand_name }}</td>
              <td><img :src="item.imageUrl.url_thumb" alt="" /></td>
              <td>{{ item.inventory }}</td>
              <td>{{ item.real_inventory }}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->

    <!-- 总库入库 -->
    <warehouseMaterialIn v-show="showIsIn" v-on:hideInAdd="hideInAdd" />
    <!-- 总库入库 end -->
    <!-- 总仓出库 -->
    <warehouseMaterialOut v-show="showIsOut" v-on:hideInOut="hideInOut" />
    <!-- 总仓出库 end -->

    <!-- 表格出库 -->
    <warehouseMaterialExcelOut
      v-show="showIsExcelOut"
      v-on:hideInExcelOut="hideInExcelOut"
    />
    <!-- 表格出库 end -->
  </div>
</template>
<script>
import axios from "axios";
import warehouseMaterialIn from "@/components/equipment/warehouseMaterialIn"; //增加
import warehouseMaterialOut from "@/components/equipment/warehouseMaterialOut.vue";
import warehouseMaterialExcelOut from "@/components/equipment/warehouseMaterialExcelOut.vue";
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: ["项目名称", "商品名称", "商品图", "总入库数量", "现存数量"],
      project_id: "",
      query_field: "",
      proList: [],
      showIsIn: false,
      showIsOut: false,
      showIsExcelOut: false
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目
  },
  components: {
    warehouseMaterialOut,
    warehouseMaterialIn,
    warehouseMaterialExcelOut
  },
  methods: {
    downloadMaterial() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_material/downloadLists?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&query_field=" +
        this.query_field +
        "&project_id=" +
        this.project_id;
    },
    hideInExcelOut() {
      this.showIsExcelOut = false;
      this.reload();
    },
    hideInOut(msg) {
      this.showIsOut = false;
      if (msg) {
        this.reload();
      }
    },
    hideInAdd(msg) {
      this.showIsIn = false;
      if (msg) {
        this.reload();
      }
    },
    showInUserList() {
      this.showIsIn = false;
      this.showIsOut = false;
      this.showIsExcelOut = false;
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onReset() {
      this.query_field = "";
      this.project_id = "";
      this.page = 1;
      this.getData();
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_material/lists";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  td {
    img {
      height: 30px;
      width: 30px;
      object-fit: cover;
    }
  }
}
</style>
